/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeDetails } from '../models/MeDetails';
import type { MeUpdate } from '../models/MeUpdate';
import { request as __request } from '../core/request';

export class MeVService {

    /**
     * @returns MeDetails OK
     * @throws ApiError
     */
    public static async meVGetMe(): Promise<MeDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/me`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns MeDetails OK
     * @throws ApiError
     */
    public static async meVUpdateMe(
        requestBody?: MeUpdate,
    ): Promise<MeDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/me`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}